import mgr from "@/security/security";
export default {
	isAuthenticated: false,
	user: "",
	role: "",
	userInfo: {
		email: "",
		phone: "",
		role: "",
		organism: "",
		orgnaismId: 0,
	},
	mgr: mgr,

	websocket: undefined,

	userForEdition: null,

	snackBar: false,
	snackText: "",
	snackUserText: "",
	snackParameter: null,

	snackDownload: false,
	selected: [],
	projectDownload: "",
	downloadInProgress: false,

	projectForDetailsPage: undefined,

	detailedProject: undefined,
	projectRaw: undefined,
	displayDrawer: false,

	auditDialog: false,
	auditResult: false,
	auditProject: 0,

	search: "",
	searchInterval: 0,
	page: 1,
	actualPage: 1,
	updateProjectViewer: 0,
	isLegalAudit: false,
	organismEdition: undefined,
	footerKey: 0,
	isOrganismEditMode: false,
	status: "",
	windowWidth: false,
	selectedItemsPerPage: 10,
	startDate: "",

	range: "day",
	selectedStatistic: "Proyectos",
	progressDownload: {
		projectId: "0",
		progress: "0",
	},
	makeRequest: false,
	disableText: null,
	secodaryUpdate: null,
	statusKey: 0,
};
